<div tabindex="0" class="me-payment-verify">
    <div class="klenico-me__background">
        <div class="klenico-me__background__inner"></div>
    </div>
    
    <div class="container" *ngIf="showLoadingPage">
        <me-payment-loading></me-payment-loading>
    </div>

    <div class="container" *ngIf="showSuccessPage">
        <me-payment-success [showDocument]="showDocument"></me-payment-success>
    </div>

    <div class="container" *ngIf="showErrorPage">
        <me-payment-error></me-payment-error>
    </div>
</div>